import React, { useEffect } from 'react'
import Header from './../header/header'
import Footer from './../footer/footer'
import './layout.scss'
import WhatsappIcon from '../../atoms/whatsapp-icon/whatsapp-icon'
import useLocaleMode from '../../../hooks/useLocaleMode'

const Layout = (props) => {
  const { locale } = useLocaleMode();

  return (
    <>
      <Header currentUser={props.currentUser} currentPoints={props.currentPoints} locale={props.locale} handleBannerPaused={props.handleBannerPaused && props.handleBannerPaused} isMobile={props.isMobile} isChangePassword={props.isChangePassword} />
      <div className={props.white ? 'f-layout-background-white' : 'f-layout-background' } >
        <main>{props.children}</main>
      </div>
      <Footer isMobile={props.isMobile}/>
      {locale === "es-CO" || locale === "es-PE" ? <WhatsappIcon /> : <></>}
    </>
  )
};

export default Layout;